import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=21e85510&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=21e85510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e85510",
  null
  
)

export default component.exports